import { v4 as uuid } from 'uuid';

import { IJsonQuery } from '../../../../../packages/api-models/common/json_query';
import { ISession } from '../types';

const SESSION_KEY = '__serp_ml_search_session_mobsite__';

export function generateSession(jsonQuery: IJsonQuery): ISession {
  const guid = uuid();
  const session = { jsonQuery, guid };

  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
    // eslint-disable-next-line no-empty
  } catch (error) {}

  return session;
}

export function restoreSession(): ISession | null {
  try {
    const sessionString = sessionStorage.getItem(SESSION_KEY);
    const session = sessionString ? JSON.parse(sessionString) : null;

    return session;
  } catch (error) {
    return null;
  }
}
